// autogenerated by channel_search/generate.py -- do not edit
import { CellularModemStates } from "@skydio/pbtypes/pbtypes/gen/telit_lte_modem/cellular_modem_states_pb";
export { CellularModemStates };

export const CELLULAR_MODEM_STATES_PB = {
  channel: "CELLULAR_MODEM_STATES_PB",
  channelId: 1768,
  type: CellularModemStates.deserializeBinary
};
